import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetChartXYAxis: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 3v18h18M7 14l4-4 3 2 4-5" />
      </svg>
    </div>
  );
};

export default WidgetChartXYAxis;
